var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "p-l-15 p-r-15" }, [
    _c("legend", { staticClass: "f-s-13 p-b-10 p-l-0" }, [
      _c("span", {
        directives: [
          {
            name: "t",
            rawName: "v-t",
            value: "API_TOKENS_USAGE_HISTORY",
            expression: "'API_TOKENS_USAGE_HISTORY'"
          }
        ]
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-xs btn-danger legend-right-button",
          attrs: { type: "button" },
          on: { click: _vm.hideUsage }
        },
        [
          _c("i", {
            staticClass: "fa fa-close",
            attrs: { "aria-hidden": "true" }
          }),
          _vm._v("\n      " + _vm._s(_vm.$t("CLOSE")) + "\n    ")
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "p-b-5" },
      [
        _c(
          "v-table",
          {
            staticClass: "table_beauty",
            attrs: {
              data: _vm.usage,
              "current-page": _vm.currentPage,
              "page-size": 10,
              "hide-sort-icons": true
            },
            on: {
              "update:currentPage": function($event) {
                _vm.currentPage = $event
              },
              "update:current-page": function($event) {
                _vm.currentPage = $event
              },
              totalPagesChanged: function($event) {
                _vm.totalPages = $event
              }
            },
            scopedSlots: _vm._u([
              {
                key: "body",
                fn: function({ displayData }) {
                  return _c(
                    "tbody",
                    {},
                    [
                      displayData.length === 0
                        ? _c("tr", [
                            _c("td", {
                              directives: [
                                {
                                  name: "t",
                                  rawName: "v-t",
                                  value: "API_TOKENS_HEADER_USAGE_NONE",
                                  expression: "'API_TOKENS_HEADER_USAGE_NONE'"
                                }
                              ],
                              attrs: { colspan: "3" }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(displayData, function(row) {
                        return _c("tr", { key: row.id }, [
                          _c("td", [_vm._v(_vm._s(row.loginTime))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(row.protectedResource))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(row.ipAddress))])
                        ])
                      })
                    ],
                    2
                  )
                }
              }
            ])
          },
          [
            _c("thead", { attrs: { slot: "head" }, slot: "head" }, [
              _c(
                "tr",
                [
                  _c("v-th", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "API_TOKENS_USAGE_DATE",
                        expression: "'API_TOKENS_USAGE_DATE'"
                      }
                    ],
                    attrs: { "default-sort": "asc", "sort-key": "loginTime" }
                  }),
                  _vm._v(" "),
                  _c("v-th", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "API_TOKENS_USAGE_RESOURCE",
                        expression: "'API_TOKENS_USAGE_RESOURCE'"
                      }
                    ],
                    attrs: { "sort-key": "protectedResource" }
                  }),
                  _vm._v(" "),
                  _c("v-th", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "API_TOKENS_USAGE_IP",
                        expression: "'API_TOKENS_USAGE_IP'"
                      }
                    ],
                    attrs: { "sort-key": "ipAddress" }
                  })
                ],
                1
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "pagination-min" }, [
          _c(
            "div",
            { staticClass: "text-center p-7" },
            [
              _c("smart-pagination", {
                attrs: {
                  "current-page": _vm.currentPage,
                  "total-pages": _vm.totalPages
                },
                on: {
                  "update:currentPage": function($event) {
                    _vm.currentPage = $event
                  },
                  "update:current-page": function($event) {
                    _vm.currentPage = $event
                  }
                }
              })
            ],
            1
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }